import { render } from "./AuthenticationCard.vue?vue&type=template&id=5c0c51ff"
const script = {}

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__